import {
  AnyAction,
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  ReducersMapObject,
} from "redux";
import thunk from "redux-thunk";
import apiMiddleware from "./middlewares/api.middleware";
import { INITIAL_STATE as CONFIG_INITIAL_STATE } from "./reducers/config.reducers";
import { INITIAL_STATE as PROMOTION_INITIAL_STATE } from "./reducers/promotion.reducers";
import { USERS_INITIAL_STATE } from "./reducers/users.reducers";
import { AUTH_LOGOUT } from "./store.types";
import { SHIPMENT_SERVICES_INITIAL_STATE } from "./reducers/shipmentServices.reducers";
import { BUNDLE_PROMOTION_INITIAL_STATE } from './reducers/bundlePromotion.reducers';
import { BULK_BUNDLE_PROMOTION_INITIAL_STATE } from "./reducers/bulkBundleUtility.reducers";
import { PAYMENT_METHODS_INITIAL_STATE } from "./reducers/paymentMethods.reducers";

const composeEnhancers =
  process.env.NODE_ENV !== "production" &&
    typeof window === "object" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose;

const configureStore = (
  preloadedState = {},
  reducers: ReducersMapObject<any>
) => {
  let combinedMiddlewares = [thunk, apiMiddleware];
  const appReducer = combineReducers({
    ...reducers,
  });
  const rootReducer = (state: any, action: AnyAction) => {
    if (action.type === AUTH_LOGOUT) {
      state = undefined;
    }

    return appReducer(state, action);
  };

  return createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(...combinedMiddlewares))
  );
};

export const INITIAL_STATE = {
  api: {},
  auth: { storeId: "" },
  config: CONFIG_INITIAL_STATE,
  promotion: PROMOTION_INITIAL_STATE,
  bundlePromotion: BUNDLE_PROMOTION_INITIAL_STATE,
  users: USERS_INITIAL_STATE,
  shipmentServices: SHIPMENT_SERVICES_INITIAL_STATE,
  bulkBundlePromotion: BULK_BUNDLE_PROMOTION_INITIAL_STATE,
  paymentMethods : PAYMENT_METHODS_INITIAL_STATE,
};

export default configureStore;

